<button
  *ngIf="isMobile"
  tuiIconButton
  class="statistics-button"
  type="button"
  appearance="icon"
  iconStart="@tui.chart-line"
  size="s"
  (click)="buttonClick.emit()"
></button>

<button
  *ngIf="isDesktop"
  tuiButton
  class="statistics-button"
  type="button"
  appearance="outline-primary"
  size="l"
  iconStart="@tui.chart-line"
  (click)="buttonClick.emit()"
>
  {{ 'common.buttons.statistics' | translate }}
</button>
